import {
	TBillingInterval,
	TPlan,
	TPlanCode,
	TSubscriptionState,
} from "@/types/TSubscription";

import API from "./api";

/** `?workspace=` for the API's WorkspaceResolver; nothing = the user's own. */
const workspaceParam = (workspaceId?: number) =>
	workspaceId === undefined ? undefined : { workspace: workspaceId };

class SubscriptionServiceClass {
	/**
	 * The plan in force, the subscription behind it, and the usage of each
	 * limit - of the user's own workspace, or of `workspaceId`, one they
	 * belong to (the /workspace and /subscription pages name it).
	 */
	fetch = (workspaceId?: number): Promise<TSubscriptionState> => {
		return API.get("subscription", {
			params: workspaceParam(workspaceId),
		}).then((res) => res.data);
	};

	/** The public plans, cheapest first. Static: fetched when the grid opens. */
	plans = (): Promise<TPlan[]> => {
		return API.get("plans").then((res) => res.data);
	};

	/** A Stripe Checkout URL for this plan and interval; the browser is to be sent there. */
	checkout = (
		plan: TPlanCode,
		interval: TBillingInterval,
		workspaceId?: number
	): Promise<string> => {
		return API.post(
			"subscription/checkout",
			{ plan, interval },
			{ params: workspaceParam(workspaceId) }
		).then((res) => res.data.url);
	};

	/** The Stripe billing portal (change plan, cancel, card, invoices). */
	portal = (workspaceId?: number): Promise<string> => {
		return API.post("subscription/portal", null, {
			params: workspaceParam(workspaceId),
		}).then((res) => res.data.url);
	};
}

const SubscriptionService = new SubscriptionServiceClass();

export default SubscriptionService;
